module.exports = __webpack_public_path__ + "img/hsa_bluebook_logo.1db196bf.png";